// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'phone';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='m11.296 16.84.009.006a4.18 4.18 0 0 0 5.2-.57l.585-.585a1.394 1.394 0 0 0 0-1.971l-2.464-2.462a1.394 1.394 0 0 0-1.97 0 1.393 1.393 0 0 1-1.971 0L6.743 7.315a1.395 1.395 0 0 1 0-1.971 1.392 1.392 0 0 0 0-1.97L4.28.908a1.395 1.395 0 0 0-1.97 0l-.586.585a4.182 4.182 0 0 0-.57 5.2l.005.01A37.724 37.724 0 0 0 11.296 16.84z'
  />
);

export const viewBox = '0 0 18 18';
